module.exports = __webpack_public_path__ + "static/media/avatar-02.d946bae4.svg";